import { TFunction } from "i18next";

export const accountsAPILinks = (t: TFunction) => {
  return [
    { name: t("sidebar.account-access-consent-request"), link: "aisp#account-access-consent-request" },
    { name: t("sidebar.account-access-consent-status"), link: "aisp#account-access-consent-status" },
    { name: t("sidebar.remove-account-access-consent"), link: "aisp#remove-account-access-consent" },
    { name: t("sidebar.accounts-request"), link: "aisp#accounts-request" },
    { name: t("sidebar.account-details-request"), link: "aisp#account-details-request" },
    { name: t("sidebar.account-balances-request"), link: "aisp#account-balances-request" },
    { name: t("sidebar.balances-request"), link: "aisp#balances-request" },
    { name: t("sidebar.account-beneficiaries-request"), link: "aisp#account-beneficiaries-request" },
    { name: t("sidebar.beneficiaries-request"), link: "aisp#beneficiaries-request" },
    { name: t("sidebar.account-direct-debits-request"), link: "aisp#account-direct-debits-request" },
    { name: t("sidebar.direct-debits-request"), link: "aisp#direct-debits-request" },
    { name: t("sidebar.party-request"), link: "aisp#party-request" },
    { name: t("sidebar.account-party-request"), link: "aisp#account-party-request" },
    { name: t("sidebar.account-parties-request"), link: "aisp#account-parties-request" },
    { name: t("sidebar.product-request"), link: "aisp#product-request" },
    { name: t("sidebar.account-product-request"), link: "aisp#account-product-request" },
    { name: t("sidebar.account-standing-orders-request"), link: "aisp#account-standing-orders-request" },
    { name: t("sidebar.standing-orders-request"), link: "aisp#standing-orders-request" },
    { name: t("sidebar.account-scheduled-payments-request"), link: "aisp#account-scheduled-payments-request" },
    { name: t("sidebar.scheduled-payments-request"), link: "aisp#scheduled-payments-request" },
    { name: t("sidebar.account-transactions-request"), link: "aisp#account-transactions-request" },
    { name: t("sidebar.transactions-request"), link: "aisp#transactions-request" },
  ];
};

export const paymentsAPILinks = (t: TFunction) => {
  return [
    { name: t("sidebar.domestic-payment-consents"), link: "pisp#domestic-payment-consents" },
    { name: t("sidebar.domestic-payment-consents-status"), link: "pisp#domestic-payment-consents-status" },
    { name: t("sidebar.funds-confirmation"), link: "pisp#funds-confirmation" },
    { name: t("sidebar.domestic-payments"), link: "pisp#domestic-payments" },
    { name: t("sidebar.domestic-payments-domesticPaymentId"), link: "pisp#domestic-payments-domesticPaymentId" },
    { name: t("sidebar.domestic-scheduled-payment-consents"), link: "pisp#domestic-scheduled-payment-consents" },
    {
      name: t("sidebar.domestic-scheduled-payment-consents-byid"),
      link: "pisp#domestic-scheduled-payment-consents-byid",
    },
    { name: t("sidebar.domestic-scheduled-payments"), link: "pisp#domestic-scheduled-payments" },
    { name: t("sidebar.domestic-scheduled-payments-byid"), link: "pisp#domestic-scheduled-payments-byid" },
    { name: t("sidebar.domestic-standing-order-consents"), link: "pisp#domestic-standing-order-consents" },
    {
      name: t("sidebar.domestic-standing-order-consents-byid"),
      link: "pisp#domestic-standing-order-consents-byid",
    },
    { name: t("sidebar.domestic-standing-order"), link: "pisp#domestic-standing-order" },
    { name: t("sidebar.domestic-standing-order-byid"), link: "pisp#domestic-standing-order-byid" },
  ];
};

export const fundsAPILinks = (t: TFunction) => {
  return [
    { name: t("sidebar.funds-confirmation-consents"), link: "cbpii#funds-confirmation-consents" },
    { name: t("sidebar.funds-confirmation-consents-byid"), link: "cbpii#funds-confirmation-consents-byid" },
    { name: t("sidebar.delete-funds-confirmation-consents"), link: "cbpii#delete-funds-confirmation-consents" },
    { name: t("sidebar.funds-confirmations"), link: "cbpii#funds-confirmations" },
  ];
};
